import PropTypes from 'prop-types'
import React from 'react'
import Nominative from './Nominative'
import NoNominative from './NoNominative'

export const options = [{ label: 'Nominativas' }, { label: 'No Nominativas' }]

export default function Factory({ request }) {
  if (request === options[0].label) return <Nominative />
  if (request === options[1].label) return <NoNominative />
  return null
}

Factory.propTypes = {
  request: PropTypes.string,
}
